// Erkennungszeichen der Schulungsumgebung (31.10.2026).
//
// Die Schulung läuft als eigene Instanz mit erfundenen Bestellungen
// (api/lib/schulung.php). Sie sieht aus wie der Echtbetrieb — das ist
// der Sinn. Damit niemand die beiden verwechselt, steht auf jeder Seite
// ein Band. Erkannt wird die Instanz an ihrer Adresse: Nur ein Hostname
// mit „schulung" zeigt es, der Echtbetrieb bleibt unberührt.

export function istSchulung(host: string = window.location.hostname): boolean {
  return host.toLowerCase().includes('schulung');
}

export function SchulungsBand() {
  if (!istSchulung()) return null;
  return (
    <div
      role="note"
      className="shrink-0 bg-coral px-4 py-1 text-center text-xs font-medium text-cream print:hidden"
    >
      Schulungsumgebung — alle Bestellungen sind erfunden. Hier darf alles ausprobiert werden.
    </div>
  );
}
